import { Dropdown, Flex, MenuProps } from 'antd';
import { css } from '@emotion/css';
import { UserOutlinedIcon } from '@miotech/prism';
import THEME, { themeWhite } from 'styles/colors';
import { useMemo } from 'react';
import { postUserLogout } from 'services/user/login.service';
import { useRequest } from 'ahooks';
import useRedux from 'hooks/useRedux';
import Logo from 'components/logo';
import { useHistory, useLocation } from 'react-router-dom';

const PtiLayoutHeader = () => {
  const {
    selector: {
      userInfo: { basicInfo },
    },
  } = useRedux(s => ({
    userInfo: s.mainApp?.userInfo,
  }));

  const history = useHistory();
  const { run } = useRequest(postUserLogout, {
    manual: true,
    onSuccess() {
      history.push(`/login?redirect-url=${encodeURIComponent(window.location.pathname + window.location.search)}`);
    },
  });

  const items: MenuProps['items'] = useMemo(() => {
    return [
      {
        key: '1',
        label: <div style={{ cursor: 'default' }}>{basicInfo?.displayName}</div>,
      },
      {
        key: '2',
        label: <div onClick={run}>Log Out</div>,
      },
    ];
  }, [basicInfo?.displayName, run]);

  const location = useLocation();
  const showTips = useMemo(() => {
    return location.pathname === '/' || location.pathname.startsWith('/admin/project-profile');
  }, [location]);

  return (
    <Flex className={cssPtiLayoutHeader} align="center" justify="space-between">
      <Flex gap={32} align="center">
        <Logo />
        <div className={cssTitle}>Generate Project Profile</div>
      </Flex>
      <Flex align="center" gap={16}>
        {showTips && <div className={cssTips}>If a network exception occurs, you can reopen the page to continue.</div>}
        {basicInfo?.displayName && (
          <Dropdown menu={{ items }} overlayClassName={cssDropdown}>
            <Flex className={cssUser} align="center" justify="center">
              <UserOutlinedIcon size={16} />
            </Flex>
          </Dropdown>
        )}
      </Flex>
    </Flex>
  );
};

export default PtiLayoutHeader;

const cssPtiLayoutHeader = css`
  height: 64px;
  padding: 0 32px;
  border-bottom: 1px solid ${THEME.fifth};
  background: ${themeWhite};
`;

const cssTitle = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

const cssUser = css`
  width: 32px;
  height: 32px;
  color: ${THEME.branding};
  cursor: pointer;

  &:hover {
    background: ${THEME.base};
    border-radius: 4px;
  }
`;

const cssDropdown = css`
  min-width: 160px !important;
`;

const cssTips = css`
  color: ${THEME.secondary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;
